import React, { PureComponent } from 'react'
import classnames from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import Shiitake from 'shiitake'

import { event } from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object.isRequired
  }

  render() {
    const {
      start,
      end,
      landlordFullName,
      address,
      status,
      type,
      customEventData
    } = this.props.event
    const title = (customEventData || {}).title
    const description = (customEventData || {}).description
    const hour = `${moment(start).format('h:mm')} - ${moment(end).format(
      'h:mm'
    )}`

    return (
      <div
        className={classnames(
          'event',
          status.toLowerCase(),
          type.toLowerCase()
        )}
        title={`${hour} - ${(landlordFullName || title)}`}
      >
        <Shiitake lines={2} throttleRate={200} style={{maxWidth:'70%'}} className="user" tagName="p">
          { `${moment(start).format('h:mm')} - ` + (landlordFullName || title)}
         </Shiitake>
        <Shiitake lines={2} throttleRate={200} className="address" tagName="p">
          {address || description || '  '}
        </Shiitake>
        <div className={classnames(
          'radio-button',
          status.toLowerCase(),
          type.toLowerCase()
        )}/>
        <style jsx>{event}</style>
      </div>
    )
  }
}
